import React from "react";
import MUIDataTable from "mui-datatables";
import {
  createMuiTheme,
  MuiThemeProvider,
} from "@material-ui/core/styles";

import axios from 'axios';
import Fab from '@material-ui/core/Fab';
import EditIcon from '@material-ui/icons/Edit';
import ViewIcon from '@material-ui/icons/Visibility';
import { Container, Row, Col } from "shards-react";
import CircularProgress from '@material-ui/core/CircularProgress';
import  api from '../common/api';

class Roles extends React.Component {

   constructor() {
      super();

      this.state = {
        data: '',
        isLoaded: false,
        roles:[]
      }
    }

    async componentDidMount() {
      await this.getUsers();
    }
   
   getUsers(){
     const token =localStorage.getItem('userToken')

     return axios
              .get(api.roles().index(),{ headers: {"Authorization" : `Bearer ${token}`} })
              .then(res => {
                this.setState({isLoaded: true, roles: res.data})
              })
              .catch(err =>{
                this.setState({isLoaded: true, roles: [] })
              })
  }

  getMuiTheme = () =>
    createMuiTheme({
      overrides: {
        MuiTableCell: {
         root: {
           padding: '0px 8px 0px 8px',
           fontSize: '0.73rem'
          }
        }
      }
  });      

  render(){
     const columns = [
     {
      name: "id",
      label: "Id",
      options: {
       filter: false,
       sort: true,
      }
     },
     {
      name: "name",
      label: "Nombre",
      options: {
       filter: true,
       filterType: "textField",
       sort: true,
      }
     },
     {
      name: "email",
      label: "Email",
      options: {
       filter: true,
       filterType: "textField",
       sort: true,
      }
     },
     {
      name: "rol",
      label: "Rol",
      options: {
       filter: true,
       filterType: "textField",
       sort: true,
      }
     },{
        name: "Acciones",
        label: "",
        options: {
            filter: false,
            setCellHeaderProps: () => ({ align: 'center' }),
            customBodyRender: (value, tableMeta, updateValue) => {
              const rowId = tableMeta.rowData[0]
              //const rowId = 1
              return (
                <div className="row" style={{display: 'block'}}>
                  <Fab color="primary" aria-label="view"  variant="extended" style={{boxShadow: 'none', backgroundColor: "green" }} fontSize="small" className='MuiButtonBase-root MuiFab-sizeSmall mr-2' href={"role/"+rowId + "/0"} >
                    <EditIcon fontSize="small" /> 
                  </Fab>
                  <Fab color="secondary" aria-label="edit" variant="extended" style={{boxShadow: 'none' }} fontSize="small" className='MuiButtonBase-root MuiFab-sizeSmall mr-2' href={"role/"+rowId+"/1"}>
                    <ViewIcon fontSize="small" /> 
                  </Fab>
                </div>
                  )}
            }
     }
    ];


  const options = {
    print:false,
    responsive: 'stacked',
    selectableRowsOnClick: true,
    download: false,
    rowsPerPage: 10,
    textLabels: {
          toolbar: {
            search: "Buscar",
            viewColumns: "Ver columnas",
            filterTable: "Filtros",   
            downloadCsv: "Exportar XLS",
          },
          body: {
              noMatch: this.state.isLoaded ?
                  'No hay resultados' :
                  <CircularProgress />,
          },
          selectedRows: {
            text: "fila(s) seleccionadas"
          },
          viewColumns: {
            title: "Ver columnas",
          },
          pagination: {
            next: "Siguiente",
            previous: "Anteior",
            rowsPerPage: "Cantidad por página:",
            displayRows: "de",      
          },
          filter: {
            all: "Todos",
            title: "Filtros",
            reset: "Limpiar"
          }
      }
  };

   return(
      <Container fluid className="main-content-container px-4">
          <Row>
            <Col className="p-2">
              <div>
             <MuiThemeProvider theme={this.getMuiTheme()}>
                <MUIDataTable
                  title="Lista de Roles"
                  data={Object.values(this.state.roles)}
                  columns={columns}
                  options={options}
                 />
              </MuiThemeProvider>
              </div>
            </Col>
          </Row>
         </Container>
    );
  }

}

export default Roles;   